function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-f2-1,.cls-f2-10,.cls-f2-11,.cls-f2-13,.cls-f2-17,.cls-f2-6,.cls-f2-7,.cls-f2-9{fill:none;}.cls-f2-2{clip-path:url(#clip-path);}.cls-f2-3{fill:#fef6f5;}.cls-f2-10,.cls-f2-12,.cls-f2-15,.cls-f2-16,.cls-f2-18,.cls-f2-3,.cls-f2-4,.cls-f2-7,.cls-f2-8{fill-rule:evenodd;}.cls-f2-4{fill:#fc965c;}.cls-f2-13,.cls-f2-4,.cls-f2-5,.cls-f2-9{stroke:#fff;}.cls-f2-10,.cls-f2-11,.cls-f2-13,.cls-f2-17,.cls-f2-4,.cls-f2-5,.cls-f2-6,.cls-f2-7,.cls-f2-9{stroke-miterlimit:10;}.cls-f2-4,.cls-f2-9{stroke-width:0.5px;}.cls-f2-5{fill:#c5deec;}.cls-f2-6,.cls-f2-7{stroke:#191415;}.cls-f2-8{fill:#b0acd2;}.cls-f2-10,.cls-f2-11{stroke:#8b827c;}.cls-f2-10,.cls-f2-11,.cls-f2-13{stroke-width:0.25px;}.cls-f2-12,.cls-f2-14{fill:#fdc232;}.cls-f2-15{fill:#bfdbe8;}.cls-f2-16{fill:#f698b5;}.cls-f2-17{stroke:#dddcd4;stroke-width:2px;}.cls-f2-18{fill:#edece8;}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-f2-1",
  width: 1180,
  height: 650
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "cls-f2-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-3",
  d: "M982.22,499.61l1,123.2-64.5-.18-31-.08-106.37-.29-8.39,0-1.12-161.85-99.51-88,29.17-34.56L570.65,221.87l-83.79-.23.34,23.85-94.71,1,1.09,47.87L132.11,295,132,271.34,121,272l.07-25.76,11-.15L129.71,55.82l261-1.34-.07,24.85,163.12.45S575.24,68.69,593.17,70l2,.16c.42,0,.84.07,1.26.12h.08l.76.08.28,0,1.18.14.75.1,1.3.17c1.49.21,2.9.45,4.25.7l.64.12.63.12.62.13c1.09.22,2.13.46,3.11.7l.55.13.54.14,2,.54.47.13.9.27.63.19c1.2.37,2.23.73,3.1,1l.58.21.27.11.26.1c.43.16.79.31,1.1.44l.43.19.15.06.27.13.18.08h0l4-25,3.36-.2,1,0,2.24-.12,3.61-.17,2.09-.1,4.22-.16q.5,0,1,0l1.54-.06,1.25,0h.51c7.62-.21,15.53-.26,23.69-.06H670q3.18.08,6.39.21l.77,0,1,0,.86,0,1,.06,2.34.12,2.47.15,1.18.08,1.41.1,1.51.11.44,0,2.11.16.21,0,2.71.24,1.4.13.72.07.93.09,2.39.25,3.5.4,1.47.17,1.89.24.84.11h0l2.31.32,1.4.2,1.71.24.5.08,2.23.35,1.58.25,1.13.19.59.09,1.65.29.87.16.45.08.45.07.9.17,1.35.25,1,.18,2.57.51.89.18,1.54.32.42.09,2,.43,1.17.26,1.45.33.84.2.31.07,1.22.28,1,.24,1.69.42c.42.1.85.2,1.27.32l.08,0,2,.52.27.07.36.09.55.15.57.15c.55.15,1.1.29,1.64.45l1.7.47,1.32.38,1.56.45,2.08.62,1.85.57,1.68.53.61.19.4.13.88.28.83.27.68.23,1,.32.45.15.35.12c1.15.39,2.29.78,3.43,1.19l1.11.4,1,.36,1.84.68,1.6.6.39.15,1.1.42,1.54.6,2.58,1,2.58,1.06c.45.19.89.37,1.33.57l.62.26.64.28,1.57.68c1.35.59,2.7,1.2,4.05,1.82l1.52.71c.79.36,1.57.73,2.34,1.1h0l2,1,3.3,1.64q1.65.84,3.3,1.71l1.65.88,1.65.89,1.65.9,1.65.92q3.3,1.85,6.59,3.83l1.65,1,1.64,1h0l1.64,1,1.64,1q1.2.76,2.4,1.56l2.27,1.5,1.13.76.89.61.74.5.55.38,1.19.84,1.2.84.4.28.92.65.63.46.88.64c1,.77,2.1,1.54,3.15,2.33l1.34,1,.67.5.7.54.7.54.54.41,1.16.92.35.27,1.35,1.07,1.7,1.37c1.63,1.32,3.27,2.68,4.9,4.07l1,.88.19.16,1.13,1,1.73,1.5.67.6,1.12,1c.39.34.78.7,1.17,1l1.17,1.07,1.62,1.48.43.4c.66.61,1.33,1.24,2,1.88l1.11,1c.51.48,1,1,1.5,1.45l.21.2,1.56,1.52s.1.11.16.16l1.37,1.37q1.88,1.86,3.74,3.79,3.45,3.57,6.74,7.13l1.39,1.51,1.86,2.05,1.31,1.47q2.12,2.39,4.15,4.75l1.11,1.3c1.18,1.38,2.34,2.77,3.47,4.15.87,1.05,1.72,2.09,2.56,3.14q1.56,1.94,3.08,3.89l0,.05c1.82,2.34,3.6,4.67,5.31,7l1.15,1.57,1.13,1.56q1.68,2.34,3.29,4.69l1.07,1.56.06.09c.78,1.14,1.55,2.28,2.3,3.43.21.32.42.63.62.95l.13.21.4.6.21.34c.2.29.39.59.58.89l.56.88c.37.59.75,1.18,1.11,1.77s.88,1.41,1.31,2.11l.65,1.06c.07.13.15.25.22.37l.87,1.46c.17.27.33.54.49.82.52.88,1,1.76,1.54,2.65.25.41.48.83.72,1.25l.52.92,1,1.78c.33.59.65,1.19,1,1.78s.64,1.18,1,1.78c.55,1,1.09,2.06,1.62,3.1.29.53.56,1.08.84,1.62s.42.82.62,1.23.28.55.41.83.19.37.28.56l.69,1.39c.07.15.14.3.22.45l.72,1.52c.2.41.4.82.59,1.24.09.18.17.37.26.55s.11.25.17.37c.49,1,1,2.08,1.43,3.13a.59.59,0,0,1,0,.08c.14.3.27.61.4.92.61,1.34,1.19,2.69,1.76,4l.33.78.32.77a.47.47,0,0,1,.06.15l.66,1.58c.18.44.36.89.53,1.33.54,1.34,1.07,2.68,1.58,4l.45,1.2.12.3.48,1.31.07.19c.35.93.68,1.85,1,2.77.12.35.25.69.36,1s.25.69.36,1c.2.55.38,1.11.57,1.66.14.39.27.78.39,1.18s.21.62.31.93.27.81.4,1.21l.54,1.67c.17.55.35,1.11.52,1.67l.51,1.66c.33,1.12.67,2.23,1,3.35l.48,1.68c.92,3.26,1.78,6.52,2.58,9.81v0h0c.19.77.37,1.55.56,2.32l0,.13s0,0,0,.07c.12.52.25,1,.37,1.57s.25,1.09.37,1.64c.38,1.69.75,3.39,1.09,5.1.21,1,.41,2,.6,3,.15.76.3,1.52.44,2.28,0,.17.06.35.09.51.16.83.31,1.65.45,2.47l.06.31c.11.6.21,1.21.31,1.81a.36.36,0,0,0,0,.11q.52,3.07,1,6.16V297c.16,1,.31,2.06.46,3.1s.29,2.11.44,3.16c.06.48.13,1,.19,1.43l0,.25c.08.56.15,1.12.22,1.68l.36,3c.12,1.06.25,2.13.36,3.2,0,.17,0,.33,0,.5.12,1,.22,2,.32,3l.06.6.27,2.78c.14,1.57.28,3.15.41,4.74.08.94.15,1.88.22,2.83.13,1.63.24,3.27.35,4.91.08,1.16.15,2.33.21,3.49s.14,2.36.2,3.55.11,2.27.16,3.41c0,.56,0,1.11.08,1.67,0,1.09.09,2.19.13,3.29,0,1.25.09,2.5.13,3.76s.08,2.65.11,4,.07,2.67.09,4c0,.93,0,1.87.05,2.81l0,1.74,0,2.78c.21,21-.38,43-1.16,66.24l13.69,13.64,10.23,10.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-4",
  d: "M441.31,204.51l-48.83.76.33,41.18.17,21.3-54.34.4.08-30.5s13.33-3.1,25.77-17.82,17.71-31.28,23.86-33.48a39.06,39.06,0,0,1,3.92-1c12.29-2.77,44.79-7.65,47.4-3.64C442.66,186.23,441.31,204.51,441.31,204.51Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-f2-5",
  x1: 697.32,
  y1: 161.29,
  x2: 694.33,
  y2: 164.73
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-f2-6",
  x1: 338.64,
  y1: 268.16,
  x2: 338.64,
  y2: 268.15
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-f2-7",
  points: "673.45 153.35 673.44 153.33 676.3 150.04 673.45 153.35"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-8",
  d: "M888.89,565.42l-1.25,57.13-106.37-.29-.75-120.15,37.34.1,0-16.8,50.83.14c4.73,3.4,5,41.94,4.7,64.21v.13A15.49,15.49,0,0,0,888.89,565.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M888.89,565.42l-1.25,57.13-106.37-.29-.75-120.15,37.34.1,0-16.8,50.83.14c4.73,3.4,5,41.94,4.7,64.21v.13A15.49,15.49,0,0,0,888.89,565.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-8",
  d: "M902.55,555.91l-9.6.34a10.11,10.11,0,0,1-10.47-10l-.16-19a2.78,2.78,0,0,1,5.12-1.52l17,26.62A2.32,2.32,0,0,1,902.55,555.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M902.55,555.91l-9.6.34a10.11,10.11,0,0,1-10.47-10l-.16-19a2.78,2.78,0,0,1,5.12-1.52l17,26.62A2.32,2.32,0,0,1,902.55,555.91Z"
}), /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-8",
  d: "M983.2,622.8L983.2,622.8l-64.5-0.2l0.1-18.1l-23-0.1l0.1-39l24.7,0.1c-0.5,2-0.7,4-0.7,6.1         c0,15,12.1,27.1,27,27.2c15,0,27.1-12.1,27.2-27c0-15-12.1-27.1-27-27.2c-0.8,0-1.5,0-2.3,0.1c-1.4-1.5-14.1-15.5-24.7-35.6         l13.9-9.6l48.3,0.1L983.2,622.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-8",
  d: "M983.2,622.8L983.2,622.8l-64.5-0.2l0.1-18.1l-23-0.1l0.1-39l24.7,0.1c-0.5,2-0.7,4-0.7,6.1         c0,15,12.1,27.1,27,27.2c15,0,27.1-12.1,27.2-27c0-15-12.1-27.1-27-27.2c-0.8,0-1.5,0-2.3,0.1c-1.4-1.5-14.1-15.5-24.7-35.6         l13.9-9.6l48.3,0.1L983.2,622.8z"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-10",
  d: "M898,365.16,888.45,408s-40,.86-42.56-.77-14.9-19.37-10-30.65,18.3-8.43,20.65-7.78,11,3.69,16,3S888.1,367,888.1,367l.86-4.37Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-f2-10",
  points: "460.08 166.17 416.99 168.53 416.17 133.8 459.25 136.27 460.08 166.17"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-f2-10",
  points: "827.32 179.06 802.05 205.33 794.73 205.86 772.72 188.44 799.84 154.43 827.32 179.06"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-10",
  d: "M613.68,128.41l-4.58,24.92a8.57,8.57,0,0,1-11.3,6.52L578,153.48l-5-28.91,26.88-8.35A10.75,10.75,0,0,1,613.68,128.41Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-f2-11",
  cx: 947.14,
  cy: 571.74,
  r: 24.65
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-10",
  d: "M927.52,541.16c-1.23,3.56-4.55,6.51-6.73,8.77s-4.49,4.68-9.49,4.33c-3.85-.28-23.94-33.84-23.94-33.84l7.5-5.46c-4.5-7.59-2.23-10.81,1.69-11.79,6.53-1.16,9.53.15,11.09,2s6.88,15.11,10.52,19.39S928.75,537.59,927.52,541.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-10",
  d: "M831.57,355.89l-7.65,4.45a4.7,4.7,0,0,1-6.08-1.2l-26.57-34.51a5.63,5.63,0,0,1,1.12-8c2.09-1.56,4.53-3.36,6.48-4.79a4.56,4.56,0,0,1,6.25.78c4.45,5.42,13.09,16.14,17.33,22.68,3.61,5.56,7.71,11.22,10.32,14.75A4,4,0,0,1,831.57,355.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-10",
  d: "M787.93,301.9l-5.73,4.64a5.69,5.69,0,0,1-7.57-.35l-30-29.47a6.88,6.88,0,0,1,0-9.83l5.17-5.05a4.57,4.57,0,0,1,6.35,0l32.14,30.69A6.27,6.27,0,0,1,787.93,301.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-10",
  d: "M733.58,251.1l-4.12,5a6.09,6.09,0,0,1-8.16,1.14l-34.43-23.76a5.42,5.42,0,0,1-1.67-7l4.29-7.9a5.14,5.14,0,0,1,7.44-1.77l35.27,24.46A6.75,6.75,0,0,1,733.58,251.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-10",
  d: "M676.78,212.35,670,220a5.83,5.83,0,0,1-6.78,1.42l-42.34-19.5a5.62,5.62,0,0,1-3.21-5.92l1.57-10.93a5.17,5.17,0,0,1,7.11-4c11.91,5,37.91,16.13,49.23,23.09A5.42,5.42,0,0,1,676.78,212.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-10",
  d: "M592.63,173.77l-1.08,7.9a5,5,0,0,1-6.37,4.15c-5.33-1.54-13.68-3.9-21.38-5.83a122.18,122.18,0,0,0-14.67-2.87,4.7,4.7,0,0,1-4.11-4.69l0-9.81a4.71,4.71,0,0,1,5.79-4.57c9.66,2.27,28.89,6.89,37.85,9.58A5.63,5.63,0,0,1,592.63,173.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-10",
  d: "M528.4,154.43l0,13.18a4.79,4.79,0,0,1-5.26,4.75l-30.11-3a6,6,0,0,1-5.42-6.16l.51-16.66,21.14,1v4.31Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-f2-10",
  points: "799.12 224.8 771.1 254.2 749.36 233.42 770.97 206.97 778.53 206.47 799.12 224.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-11",
  d: "M554.26,79.55V93.71l9.27.41,2.2,16.85,53.54-16,3-18.49s-17.37-7.42-34.36-6.61S554.26,79.55,554.26,79.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-12",
  d: "M698.13,91.67c-4.1-1-8-1.9-11.19-2.48-6.9-1.24-28.64,2.1-28.64,2.1l0-11.05,15.84,0-.56-29.92,2.29.09,1.74.07.56,0c.42,0,.86,0,1.29.06h.31l2.65.14,3.14.19,1.21.09,1.76.13,2.9.22,3,.26,3,.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-13",
  d: "M698.13,91.67c-4.1-1-8-1.9-11.19-2.48-6.9-1.24-28.64,2.1-28.64,2.1l0-11.05,15.84,0-.56-29.92,2.29.09,1.74.07.56,0c.42,0,.86,0,1.29.06h.31l2.65.14,3.14.19,1.21.09,1.76.13,2.9.22,3,.26,3,.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-12",
  d: "M762.58,65.72,732,100.21c-1.44-.21-2.72-.42-3.76-.63-4.24-.84-18.13-4.94-30.14-7.91l-.57-39.73A294,294,0,0,1,762.58,65.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M762.58,65.72,732,100.21c-1.44-.21-2.72-.42-3.76-.63-4.24-.84-18.13-4.94-30.14-7.91l-.57-39.73A294,294,0,0,1,762.58,65.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-12",
  d: "M795.08,111.85l-9.69,10.6s-11.73-9.08-21.81-14.51c-8.61-4.64-23-6.42-31.55-7.73l30.55-34.49h0l.34.12c1.15.38,2.29.78,3.43,1.19l1.11.4q3,1.06,5.94,2.21l1.54.6c.86.34,1.72.68,2.58,1l2.58,1.06c.45.19.89.37,1.33.57l2.1.9,2.31,1,1.9.86c.69.31,1.39.64,2.09,1l1.35.63c1,.47,2,.95,3,1.44l-16.37,17,17,15.93h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-13",
  d: "M795.08,111.85l-9.69,10.6s-11.73-9.08-21.81-14.51c-8.61-4.64-23-6.42-31.55-7.73l30.55-34.49h0l.34.12c1.15.38,2.29.78,3.43,1.19l1.11.4q3,1.06,5.94,2.21l1.54.6c.86.34,1.72.68,2.58,1l2.58,1.06c.45.19.89.37,1.33.57l2.1.9,2.31,1,1.9.86c.69.31,1.39.64,2.09,1l1.35.63c1,.47,2,.95,3,1.44l-16.37,17,17,15.93h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-12",
  d: "M858.52,122.88l-31.43,35c-9.3-8.15-21.39-25.62-35-31.19l9-10.43,19.5-22.71q1.2.76,2.4,1.56l2.39,1.58,1.9,1.29q1.85,1.26,3.68,2.56l1.32.93,1.16.85,1.5,1.09c.67.49,1.33,1,2,1.49l1.34,1c.87.65,1.74,1.32,2.61,2l1.19.93.32.26,1.35,1.07,1.7,1.37q3,2.46,6.08,5.07l1.18,1c1.17,1,2.35,2,3.52,3.1C857,121.46,857.75,122.16,858.52,122.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-13",
  d: "M858.52,122.88l-31.43,35c-9.3-8.15-21.39-25.62-35-31.19l9-10.43,19.5-22.71q1.2.76,2.4,1.56l2.39,1.58,1.9,1.29q1.85,1.26,3.68,2.56l1.32.93,1.16.85,1.5,1.09c.67.49,1.33,1,2,1.49l1.34,1c.87.65,1.74,1.32,2.61,2l1.19.93.32.26,1.35,1.07,1.7,1.37q3,2.46,6.08,5.07l1.18,1c1.17,1,2.35,2,3.52,3.1C857,121.46,857.75,122.16,858.52,122.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-12",
  d: "M891,157,873,178.74l-9.18,11.12c-7.66-11.77-25.52-23.18-35-30.52-.56-.43-1.13-.9-1.72-1.42l31.43-35c.68.62,1.37,1.24,2.05,1.88l2,1.88c2,1.87,3.94,3.78,5.91,5.75.43.43.87.86,1.29,1.29.82.82,1.63,1.66,2.45,2.5q3.45,3.57,6.74,7.13l1.39,1.51q2.6,2.85,5.07,5.68l1.13,1.29,2.23,2.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-13",
  d: "M891,157,873,178.74l-9.18,11.12c-7.66-11.77-25.52-23.18-35-30.52-.56-.43-1.13-.9-1.72-1.42l31.43-35c.68.62,1.37,1.24,2.05,1.88l2,1.88c2,1.87,3.94,3.78,5.91,5.75.43.43.87.86,1.29,1.29.82.82,1.63,1.66,2.45,2.5q3.45,3.57,6.74,7.13l1.39,1.51q2.6,2.85,5.07,5.68l1.13,1.29,2.23,2.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-12",
  d: "M926.72,210.25,896.86,246.1c-2.56-8.43-5.39-17.65-7.65-23.27-4.4-11-20.29-26.56-20.29-26.56l9.17-11.86L895,199.21,909.88,182h0s0,.06.05.09q2.19,3.21,4.24,6.42l.56.88q.57.89,1.11,1.77l1.31,2.11q2.61,4.26,5,8.53l1,1.78c.33.59.65,1.19,1,1.78s.64,1.18,1,1.78C925.65,208.18,926.19,209.21,926.72,210.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-13",
  d: "M926.72,210.25,896.86,246.1c-2.56-8.43-5.39-17.65-7.65-23.27-4.4-11-20.29-26.56-20.29-26.56l9.17-11.86L895,199.21,909.88,182h0s0,.06.05.09q2.19,3.21,4.24,6.42l.56.88q.57.89,1.11,1.77l1.31,2.11q2.61,4.26,5,8.53l1,1.78c.33.59.65,1.19,1,1.78s.64,1.18,1,1.78C925.65,208.18,926.19,209.21,926.72,210.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-12",
  d: "M947.11,263,908,275.23c-2.18-5.05-4.3-8.51-5.36-11-1.2-2.8-3.39-10.12-5.82-18.15l29.86-35.85A261.18,261.18,0,0,1,947.11,263Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-13",
  d: "M947.11,263,908,275.23c-2.18-5.05-4.3-8.51-5.36-11-1.2-2.8-3.39-10.12-5.82-18.15l29.86-35.85A261.18,261.18,0,0,1,947.11,263Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-12",
  d: "M932.71,312.78l.87,16.58-17.68.93a.77.77,0,0,1-.81-.92c.36-1.93.79-7.62-.25-24.22-.85-13.7-3.89-23.21-6.8-29.92L947.11,263a328.25,328.25,0,0,1,9.12,49.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-13",
  d: "M932.71,312.78l.87,16.58-17.68.93a.77.77,0,0,1-.81-.92c.36-1.93.79-7.62-.25-24.22-.85-13.7-3.89-23.21-6.8-29.92L947.11,263a328.25,328.25,0,0,1,9.12,49.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-14",
  d: "M651.69,91.79c-7.31,0-33.26,3.48-33.26,3.48l3-19h0l4-25,2.79-.16,2.53-.14,1.24-.07,3.61-.17,2.09-.1,4.22-.16.79,0,2.16-.07,3.85-.1.4,28.4h2.27l0,1.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-13",
  d: "M651.69,91.79c-7.31,0-33.26,3.48-33.26,3.48l3-19h0l4-25,2.79-.16,2.53-.14,1.24-.07,3.61-.17,2.09-.1,4.22-.16.79,0,2.16-.07,3.85-.1.4,28.4h2.27l0,1.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-12",
  d: "M869.29,218.77l-12.55,15-36.28-32.13,15-16a7.07,7.07,0,0,1,10.66.42C853.84,195.75,867.69,213.52,869.29,218.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-13",
  d: "M869.29,218.77l-12.55,15-36.28-32.13,15-16a7.07,7.07,0,0,1,10.66.42C853.84,195.75,867.69,213.52,869.29,218.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-12",
  d: "M655.35,137.33l1.7,1.5-9.7,10.75-26.58-.08c.08-.88.19-1.8.35-2.73,2.52-15.14,3.59-22.93,3.59-23.54,1.85-10.53,13.62-18.72,25-19.6a208.67,208.67,0,0,1,22.81-.19l.65,13.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-13",
  d: "M655.35,137.33l1.7,1.5-9.7,10.75-26.58-.08c.08-.88.19-1.8.35-2.73,2.52-15.14,3.59-22.93,3.59-23.54,1.85-10.53,13.62-18.72,25-19.6a208.67,208.67,0,0,1,22.81-.19l.65,13.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-12",
  d: "M754.49,120.23l-19.25,23.84-13.16-11.13-24.29,27.8-17.26-15.51,11.05-12.91,20.89-24.39a.5.5,0,0,0,.13,0A212.57,212.57,0,0,1,754.49,120.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-13",
  d: "M754.49,120.23l-19.25,23.84-13.16-11.13-24.29,27.8-17.26-15.51,11.05-12.91,20.89-24.39a.5.5,0,0,0,.13,0A212.57,212.57,0,0,1,754.49,120.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-12",
  d: "M712.47,107.93l-20.89,24.39L676.3,150l-2.86,3.29-16.39-14.5-1.7-1.5,17.81-20.19-.65-13.7A276.15,276.15,0,0,1,712.47,107.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-13",
  d: "M712.47,107.93l-20.89,24.39L676.3,150l-2.86,3.29-16.39-14.5-1.7-1.5,17.81-20.19-.65-13.7A276.15,276.15,0,0,1,712.47,107.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-12",
  d: "M790.21,142.78c0,7.57-29.1,40.14-29.1,40.14L732.2,158.08l28.46-34.48C782.4,133.15,790.22,137.6,790.21,142.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-13",
  d: "M790.21,142.78c0,7.57-29.1,40.14-29.1,40.14L732.2,158.08l28.46-34.48C782.4,133.15,790.22,137.6,790.21,142.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M509.77,103.24l0,19.67c-12.88,0-42-.5-42-.5v-5.35l-5.37,0L462,79.53l38.58.1-.07,23.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M509.77,103.24l0,19.67c-12.88,0-42-.5-42-.5v-5.35l-5.37,0L462,79.53l38.58.1-.07,23.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M567.49,110.45c-3.2,1.65-21,6.53-35,9.55l-.43.09,0-16.92h.43l8.65,0,.06-23.46,12.6,0,.06,0,.4-.19.42,13.64,9.27.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M567.49,110.45c-3.2,1.65-21,6.53-35,9.55l-.43.09,0-16.92h.43l8.65,0,.06-23.46,12.6,0,.06,0,.4-.19.42,13.64,9.27.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M606.82,218.6l-17.44,19.88-18.73-16.61h-.26l10.82-11.54L581,194.18c10.31,3.34,17.22,6.38,19,8.15C603.24,205.6,605.51,214.81,606.82,218.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M606.82,218.6l-17.44,19.88-18.73-16.61h-.26l10.82-11.54L581,194.18c10.31,3.34,17.22,6.38,19,8.15C603.24,205.6,605.51,214.81,606.82,218.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M487.2,245.5l-23.76.24-2.09-35.56-8.44.41-.44-26.72a4.92,4.92,0,0,1,4.8-5l29-.74.61,43.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M487.2,245.5l-23.76.24-2.09-35.56-8.44.41-.44-26.72a4.92,4.92,0,0,1,4.8-5l29-.74.61,43.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M702.55,305.23l-16.81,18.69L649.4,291.7l40.7-46.5c8.61,5.55,16.63,11.51,17.8,14.22C710.36,265.17,702.55,305.23,702.55,305.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M702.55,305.23l-16.81,18.69L649.4,291.7l40.7-46.5c8.61,5.55,16.63,11.51,17.8,14.22C710.36,265.17,702.55,305.23,702.55,305.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M690.1,245.2l-40.7,46.5-18.33-16.25,17-18.29-12.76-11.65,7.6-9.12c5.6,6,20.64-3.21,24.81-3.19C670,233.2,680.41,238.94,690.1,245.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M690.1,245.2l-40.7,46.5-18.33-16.25,17-18.29-12.76-11.65,7.6-9.12c5.6,6,20.64-3.21,24.81-3.19C670,233.2,680.41,238.94,690.1,245.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M971.66,446.6l-70.36.53a228.56,228.56,0,0,1,1.28-49.57l24.15.06,0,12.28,7,0,0,6.13,24.77.07c-.15,5.54-.34,11.15-.53,16.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M971.66,446.6l-70.36.53a228.56,228.56,0,0,1,1.28-49.57l24.15.06,0,12.28,7,0,0,6.13,24.77.07c-.15,5.54-.34,11.15-.53,16.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M982,475.85l-12.83,0,0,17.11-37.86-.1-14.78,8.83c-9.27-16.8-13.6-36.22-15.23-54.51l70.36-.54h0l10.22,10.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M982,475.85l-12.83,0,0,17.11-37.86-.1-14.78,8.83c-9.27-16.8-13.6-36.22-15.23-54.51l70.36-.54h0l10.22,10.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M636,232.65l-11.52,12.69-3.46-2.68-6.42,7.23-14.26-12.64-5.43,6.16-5.56-4.93,17.44-19.88a1.07,1.07,0,0,0,.07.19C608.18,222.45,636,232.65,636,232.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M636,232.65l-11.52,12.69-3.46-2.68-6.42,7.23-14.26-12.64-5.43,6.16-5.56-4.93,17.44-19.88a1.07,1.07,0,0,0,.07.19C608.18,222.45,636,232.65,636,232.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M581.21,210.33l-10.82,11.54-37.69-.1.11-39.11A350.66,350.66,0,0,1,581,194.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M581.21,210.33l-10.82,11.54-37.69-.1.11-39.11A350.66,350.66,0,0,1,581,194.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M532.81,182.66l-.11,39.11-22.39-.06L510,179.57C517.77,180.36,525.43,181.42,532.81,182.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M532.81,182.66l-.11,39.11-22.39-.06L510,179.57C517.77,180.36,525.43,181.42,532.81,182.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M510.31,221.71l-23.45-.07-.61-43.51c7.92.13,15.89.65,23.73,1.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M510.31,221.71l-23.45-.07-.61-43.51c7.92.13,15.89.65,23.73,1.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M927.82,380.65l-21.41,0s1.51-27.94,7-43.88l14.13,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M927.82,380.65l-21.41,0s1.51-27.94,7-43.88l14.13,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M851.14,443l-33.68-.09,0-9.29,24-11.88C844.71,428.65,848,436,851.14,443Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M851.14,443l-33.68-.09,0-9.29,24-11.88C844.71,428.65,848,436,851.14,443Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M817.49,433.65v-.55l-19.85-.05-5.2-6.16L824,391.21c3.16,1.71,10.11,14.94,17.47,30.56Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M817.49,433.65v-.55l-19.85-.05-5.2-6.16L824,391.21c3.16,1.71,10.11,14.94,17.47,30.56Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M857.52,457.67l-40.1-.11,0-14.62,33.68.09C853.42,448.18,855.59,453.16,857.52,457.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M857.52,457.67l-40.1-.11,0-14.62,33.68.09C853.42,448.18,855.59,453.16,857.52,457.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M866.06,477.88l-48.69-.13,0-20.19,40.1.11C862.55,469.36,866.06,477.88,866.06,477.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M866.06,477.88l-48.69-.13,0-20.19,40.1.11C862.55,469.36,866.06,477.88,866.06,477.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M894.34,491.54l-10.29,0a5.2,5.2,0,0,1-5-3.88L877,480a5.24,5.24,0,0,1,4-6.46l10.46-2.22a4.06,4.06,0,0,1,4.72,2.73l3.36,10.33A5.46,5.46,0,0,1,894.34,491.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M894.34,491.54l-10.29,0a5.2,5.2,0,0,1-5-3.88L877,480a5.24,5.24,0,0,1,4-6.46l10.46-2.22a4.06,4.06,0,0,1,4.72,2.73l3.36,10.33A5.46,5.46,0,0,1,894.34,491.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M889.44,463.66l-14.29,3.61a4.3,4.3,0,0,1-5-2.39l-5.32-11.71,14.22-7.5,12.86.21c0,.56.1,1,.15,1.26.29,1.73,1,6.38,1.6,10.1A5.72,5.72,0,0,1,889.44,463.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M889.44,463.66l-14.29,3.61a4.3,4.3,0,0,1-5-2.39l-5.32-11.71,14.22-7.5,12.86.21c0,.56.1,1,.15,1.26.29,1.73,1,6.38,1.6,10.1A5.72,5.72,0,0,1,889.44,463.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M808.23,362.14l-25.88,30.25-35.89-31.86L779,324.35C788.74,335.86,799.13,349.06,808.23,362.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M808.23,362.14l-25.88,30.25-35.89-31.86L779,324.35C788.74,335.86,799.13,349.06,808.23,362.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M821.58,383l-21.52,25.07-17.71-15.72,25.88-30.25C813.17,369.24,817.72,376.31,821.58,383Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M821.58,383l-21.52,25.07-17.71-15.72,25.88-30.25C813.17,369.24,817.72,376.31,821.58,383Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M779,324.35l-32.54,36.18-18.69-16.59,7.61-9.51-4.81-4.21-18.9-16.57a29.8,29.8,0,0,0,3.48-3.64c1.14-1.57.9-10.18,2.39-12.44s25.18-9.28,27.35-8.18C749.08,291.49,763.19,305.7,779,324.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M779,324.35l-32.54,36.18-18.69-16.59,7.61-9.51-4.81-4.21-18.9-16.57a29.8,29.8,0,0,0,3.48-3.64c1.14-1.57.9-10.18,2.39-12.44s25.18-9.28,27.35-8.18C749.08,291.49,763.19,305.7,779,324.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-12",
  d: "M902.44,316.44l-22.36-.07L877,319.78l-17.87-16-17.25-15.5,1-1.21,22.93-27.27-12.33-11.61,19.73-22.32C889.32,258,902.35,291.31,902.44,316.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-13",
  d: "M902.44,316.44l-22.36-.07L877,319.78l-17.87-16-17.25-15.5,1-1.21,22.93-27.27-12.33-11.61,19.73-22.32C889.32,258,902.35,291.31,902.44,316.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-8",
  d: "M902.44,316.44c.07,16.63-5.54,29.65-19.67,36.32-7.06,3.34-13.33,4.47-19,3.94l.06-22.61L877,319.78l3.12-3.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M902.44,316.44c.07,16.63-5.54,29.65-19.67,36.32-7.06,3.34-13.33,4.47-19,3.94l.06-22.61L877,319.78l3.12-3.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M877,319.78l-13.11,14.31-.06,22.61c-12.81-1.19-22.49-10.84-31.24-22.46l26.54-30.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M877,319.78l-13.11,14.31-.06,22.61c-12.81-1.19-22.49-10.84-31.24-22.46l26.54-30.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M859.09,303.74l-26.54,30.5c-4.87-6.48-9.47-13.57-14.15-20.14l23.4-25.9,0,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M859.09,303.74l-26.54,30.5c-4.87-6.48-9.47-13.57-14.15-20.14l23.4-25.9,0,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M841.8,288.2l-23.4,25.9a115.63,115.63,0,0,0-10.35-12.89l21.14-25.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M841.8,288.2l-23.4,25.9a115.63,115.63,0,0,0-10.35-12.89l21.14-25.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M823.71,272l-21,23.17L780,270.47a6,6,0,0,1,.08-8.25L808.24,233l9.12,7.86L804.7,255.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M823.71,272l-21,23.17L780,270.47a6,6,0,0,1,.08-8.25L808.24,233l9.12,7.86L804.7,255.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M856.74,233.82,840,253.94s-27.79-24.27-28.74-25.75-1-15.59-1-15.59l10.25-10.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M856.74,233.82,840,253.94s-27.79-24.27-28.74-25.75-1-15.59-1-15.59l10.25-10.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M762.17,199.63c-.19.39-6.64,8.32-13.08,16.19L732.89,201l4.16-4.67-2.4-3.28,8.25-9.37,5.4,5.17,4.19-4.56s8.86,6.95,9.45,7.73S762.57,198.85,762.17,199.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M762.17,199.63c-.19.39-6.64,8.32-13.08,16.19L732.89,201l4.16-4.67-2.4-3.28,8.25-9.37,5.4,5.17,4.19-4.56s8.86,6.95,9.45,7.73S762.57,198.85,762.17,199.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M749.09,215.82c-4.21,5.16-8.42,10.28-10.87,13.28a3.87,3.87,0,0,1-5.07.81c-4-2.57-11.73-7.48-19.44-12.42l16.55-18.86,2.63,2.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M749.09,215.82c-4.21,5.16-8.42,10.28-10.87,13.28a3.87,3.87,0,0,1-5.07.81c-4-2.57-11.73-7.48-19.44-12.42l16.55-18.86,2.63,2.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M732.22,196.42l-2,2.21-16.55,18.86c-9.19-5.9-18.41-11.83-21.46-13.93l21-23.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M732.22,196.42l-2,2.21-16.55,18.86c-9.19-5.9-18.41-11.83-21.46-13.93l21-23.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M673.44,153.33,649,181.41c-6.3-3.1-11.63-5.64-14.14-6.67-8.16-3.33-15.31-11.71-14.07-25.24l26.58.08,9.7-10.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M673.44,153.33,649,181.41c-6.3-3.1-11.63-5.64-14.14-6.67-8.16-3.33-15.31-11.71-14.07-25.24l26.58.08,9.7-10.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M680.53,145.23l17.26,15.51h0l-.47.54-3,3.43h0l-23.81,27.46c-6.77-3.43-14.72-7.42-21.54-10.78l24.46-28.08v0l7.08-8.12"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M680.53,145.23l17.26,15.51h0l-.47.54-3,3.43h0l-23.81,27.46c-6.77-3.43-14.72-7.42-21.54-10.78l24.46-28.08v0l7.08-8.12"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M706.29,176.24,685.86,200s-6.71-3.44-15.34-7.8l23.81-27.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M706.29,176.24,685.86,200s-6.71-3.44-15.34-7.8l23.81-27.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M532.49,103.17l0,16.83v.1c-6.77,1.45-12.64,2.45-15.55,2.44l.05-19.41,15.11,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M532.49,103.17l0,16.83v.1c-6.77,1.45-12.64,2.45-15.55,2.44l.05-19.41,15.11,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M573.72,148.14c-.54,1.43-5.11,5.79-6.43,5.85a58.31,58.31,0,0,1-6.68-1.14c-.11-2.37-.39-9.17-.44-14.65l12.32-.23C573.15,140.73,574.25,146.71,573.72,148.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M573.72,148.14c-.54,1.43-5.11,5.79-6.43,5.85a58.31,58.31,0,0,1-6.68-1.14c-.11-2.37-.39-9.17-.44-14.65l12.32-.23C573.15,140.73,574.25,146.71,573.72,148.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M560.61,152.85c-6-1.25-14.08-3.35-15.26-5.18-.77-1.2-1.08-5.07-1.19-9.17l16-.3C560.22,143.68,560.5,150.48,560.61,152.85Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M560.61,152.85c-6-1.25-14.08-3.35-15.26-5.18-.77-1.2-1.08-5.07-1.19-9.17l16-.3C560.22,143.68,560.5,150.48,560.61,152.85Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M560.17,137.92v.28l-16,.3c-.08-3.15,0-6.44,0-8.74a4.08,4.08,0,0,1,3-3.82c3.3-.9,6.85-1.93,10.1-2.87C558.25,126.16,560.14,132.86,560.17,137.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M560.17,137.92v.28l-16,.3c-.08-3.15,0-6.44,0-8.74a4.08,4.08,0,0,1,3-3.82c3.3-.9,6.85-1.93,10.1-2.87C558.25,126.16,560.14,132.86,560.17,137.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M560.17,138.2v-.28c0-5.06-1.92-11.76-2.87-14.85,5.69-1.62,10.51-2.91,11.63-2.5,2,.73,2.91,14.64,3.56,17.38v0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M560.17,138.2v-.28c0-5.06-1.92-11.76-2.87-14.85,5.69-1.62,10.51-2.91,11.63-2.5,2,.73,2.91,14.64,3.56,17.38v0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-15",
  d: "M515.6,131.53l0,11.16s16.18,4.94,19.06,1.88,2.58-13-1-14.82S515.6,131.53,515.6,131.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M515.6,131.53l0,11.16s16.18,4.94,19.06,1.88,2.58-13-1-14.82S515.6,131.53,515.6,131.53Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-f2-15",
  points: "483.55 132.03 510.55 131.78 510.52 141.24 506.43 141.23 506.43 143.78 483.52 142.28 483.55 132.03"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-f2-9",
  points: "483.55 132.03 510.55 131.78 510.52 141.24 506.43 141.23 506.43 143.78 483.52 142.28 483.55 132.03"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-f2-16",
  points: "393.58 294.33 132.1 295.02 132 271.34 121.03 272.01 121.1 246.24 132.07 246.1 129.71 55.82 166.27 55.64 167.99 269.44 338.64 268.15 392.98 267.75 393.06 271.1 393.58 294.33"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-f2-9",
  points: "393.58 294.33 132.1 295.02 132 271.34 121.03 272.01 121.1 246.24 132.07 246.1 129.71 55.82 166.27 55.64 167.99 269.44 338.64 268.15 392.98 267.75 393.06 271.1 393.58 294.33"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-16",
  d: "M338.72,237.73l-.08,30.42L168,269.44l-1.72-213.8,152.25-.79,1.23,30.85a1.56,1.56,0,0,1-1.55,1.63L202,87.75A11.5,11.5,0,0,0,190.56,99.4l1.51,132.71a12.55,12.55,0,0,0,12.73,12.4L302.54,243C311.93,243.06,325.75,241.93,338.72,237.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M338.72,237.73l-.08,30.42L168,269.44l-1.72-213.8,152.25-.79,1.23,30.85a1.56,1.56,0,0,1-1.55,1.63L202,87.75A11.5,11.5,0,0,0,190.56,99.4l1.51,132.71a12.55,12.55,0,0,0,12.73,12.4L302.54,243C311.93,243.06,325.75,241.93,338.72,237.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-16",
  d: "M462,117.08l-3.46.32V122c-8.35.2-39.19,1.95-67.78-6.09-19.69-5.55-38.31-15.75-47.8-34.31l6.66-.11L349,54.7l41.72-.22-.07,24.85,70.73.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M462,117.08l-3.46.32V122c-8.35.2-39.19,1.95-67.78-6.09-19.69-5.55-38.31-15.75-47.8-34.31l6.66-.11L349,54.7l41.72-.22-.07,24.85,70.73.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-16",
  d: "M266.56,95.27l59.2.16A2.26,2.26,0,0,1,328,97.69l-.09,32.94a2.16,2.16,0,0,1-2.15,2.16l-58.55.32a3.26,3.26,0,0,1-3.27-3.2l-.51-31.48A3.11,3.11,0,0,1,266.56,95.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M266.56,95.27l59.2.16A2.26,2.26,0,0,1,328,97.69l-.09,32.94a2.16,2.16,0,0,1-2.15,2.16l-58.55.32a3.26,3.26,0,0,1-3.27-3.2l-.51-31.48A3.11,3.11,0,0,1,266.56,95.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-16",
  d: "M200.54,96.19l53.75-.49a2.48,2.48,0,0,1,2.5,2.46l.29,32.49a2.49,2.49,0,0,1-2.43,2.51l-53.22,1.05a2.48,2.48,0,0,1-2.53-2.42l-.82-33A2.48,2.48,0,0,1,200.54,96.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M200.54,96.19l53.75-.49a2.48,2.48,0,0,1,2.5,2.46l.29,32.49a2.49,2.49,0,0,1-2.43,2.51l-53.22,1.05a2.48,2.48,0,0,1-2.53-2.42l-.82-33A2.48,2.48,0,0,1,200.54,96.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-16",
  d: "M201.44,140.5l53.17-.58a2.49,2.49,0,0,1,2.51,2.45l.44,33a2.49,2.49,0,0,1-2.44,2.52l-53.1.81a2.48,2.48,0,0,1-2.52-2.44L199,143A2.48,2.48,0,0,1,201.44,140.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M201.44,140.5l53.17-.58a2.49,2.49,0,0,1,2.51,2.45l.44,33a2.49,2.49,0,0,1-2.44,2.52l-53.1.81a2.48,2.48,0,0,1-2.52-2.44L199,143A2.48,2.48,0,0,1,201.44,140.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-16",
  d: "M202.18,184.86l53,.15a2.48,2.48,0,0,1,2.47,2.44l.74,45.27a2.48,2.48,0,0,1-2.45,2.53l-53.75.73a2.49,2.49,0,0,1-2.51-2.49l.05-46.15A2.48,2.48,0,0,1,202.18,184.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M202.18,184.86l53,.15a2.48,2.48,0,0,1,2.47,2.44l.74,45.27a2.48,2.48,0,0,1-2.45,2.53l-53.75.73a2.49,2.49,0,0,1-2.51-2.49l.05-46.15A2.48,2.48,0,0,1,202.18,184.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-16",
  d: "M264.63,187.54l.69,45.1a2.48,2.48,0,0,0,2.37,2.44c10.13.43,50.47,1.7,66.79-4.62C352.29,223.55,371.7,206,375,187.35a2.48,2.48,0,0,0-2.46-2.9L267.1,185A2.49,2.49,0,0,0,264.63,187.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M264.63,187.54l.69,45.1a2.48,2.48,0,0,0,2.37,2.44c10.13.43,50.47,1.7,66.79-4.62C352.29,223.55,371.7,206,375,187.35a2.48,2.48,0,0,0-2.46-2.9L267.1,185A2.49,2.49,0,0,0,264.63,187.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-16",
  d: "M337.83,177.2l53.07.14a2.46,2.46,0,0,0,2-1.07,45.41,45.41,0,0,0,7.39-25.15,48.41,48.41,0,0,0-7-25.56,2.45,2.45,0,0,0-1.94-1.13c-11.27-.74-32.71-11.1-48.56-27.74a2.45,2.45,0,0,0-1.79-.78h-3.32a2.48,2.48,0,0,0-2.49,2.49l.16,76.33A2.48,2.48,0,0,0,337.83,177.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M337.83,177.2l53.07.14a2.46,2.46,0,0,0,2-1.07,45.41,45.41,0,0,0,7.39-25.15,48.41,48.41,0,0,0-7-25.56,2.45,2.45,0,0,0-1.94-1.13c-11.27-.74-32.71-11.1-48.56-27.74a2.45,2.45,0,0,0-1.79-.78h-3.32a2.48,2.48,0,0,0-2.49,2.49l.16,76.33A2.48,2.48,0,0,0,337.83,177.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-16",
  d: "M264.67,156.16l-.05,19.06a2.86,2.86,0,0,0,2.9,2.87l59.4-.89a2,2,0,0,0,1.93-2l-.31-20a2.13,2.13,0,0,0-2.15-2.1l-59.26.61A2.48,2.48,0,0,0,264.67,156.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-9",
  d: "M264.67,156.16l-.05,19.06a2.86,2.86,0,0,0,2.9,2.87l59.4-.89a2,2,0,0,0,1.93-2l-.31-20a2.13,2.13,0,0,0-2.15-2.1l-59.26.61A2.48,2.48,0,0,0,264.67,156.16Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-f2-17",
  x1: 801.2,
  y1: 116.41,
  x2: 801.04,
  y2: 116.3
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-f2-18",
  points: "869.15 485.64 818.32 485.5 818.27 502.3 780.93 502.19 781.68 622.34 773.3 622.32 772.17 460.48 672.66 372.47 701.83 337.91 716.28 348.42 730.98 330.3 735.79 334.52 728.19 344.02 746.87 360.61 782.76 392.47 800.47 408.2 822 383.13 824.41 391.29 792.85 426.98 798.05 433.13 817.9 433.18 817.9 433.74 817.88 443.02 817.83 457.64 817.78 477.83 866.47 477.97 869.15 485.64"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-18",
  d: "M910.29,182.1l-14.85,17.2L878.5,184.5l-5.07-5.68,17.94-21.76c.43.52.86,1.05,1.3,1.57.86,1,1.71,2.09,2.55,3.13q3.15,3.92,6.1,7.83,1.18,1.56,2.34,3.12l1.14,1.57,1.13,1.56q1.68,2.35,3.29,4.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-18",
  d: "M821,93.67l-19.5,22.71-6.18-4.64,0,0-17-15.93,16.36-17c1.1.54,2.21,1.09,3.3,1.65s2.2,1.13,3.31,1.7l1.65.88,1.65.89,1.65.9,1.64.92c2.2,1.24,4.4,2.51,6.59,3.84l1.65,1,1.64,1h0c.55.34,1.1.68,1.64,1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-18",
  d: "M674.37,80.36l-15.84,0H651.6l0-1.58H649.3l-.4-28.39c3.52-.08,7.1-.13,10.73-.13q5.16,0,10.45.13h.14l3.59.11Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-f2-18",
  points: "541.61 79.83 541.55 103.28 532.9 103.26 532.47 103.26 517.36 103.22 517.31 122.62 510.13 123 510.18 103.33 500.87 103.3 500.94 79.72 541.61 79.83"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-f2-18",
  points: "648.52 257.25 631.49 275.53 595.35 243.49 600.78 237.33 615.04 249.97 621.47 242.74 624.92 245.43 636.44 232.73 643.35 236.47 635.75 245.59 648.52 257.25"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-f2-18",
  points: "934.16 410 959.08 410 958.92 416.2 934.14 416.13 934.16 410"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-f2-18",
  points: "934.16 380.74 959.08 380.74 959.27 386.94 934.14 386.87 934.16 380.74"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-f2-18",
  d: "M958.62,337.29,928,336.84l-.29-7.07,6.29-.33-.87-16.58h23.52v.06l.06.5c.11,1,.21,2,.31,3,0,.2,0,.4.07.6.08.93.17,1.86.26,2.78.14,1.58.28,3.16.41,4.74.08.94.15,1.89.22,2.83.13,1.63.24,3.27.35,4.91.08,1.16.15,2.33.21,3.5Z"
}));

function SvgMapF2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1180 650",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapF2);
export default __webpack_public_path__ + "static/media/map_f2.5b8e1b64.svg";
export { ForwardRef as ReactComponent };